;(function () {
    const form = document.querySelector('#popup-search')
    const toggles = document.querySelectorAll('[data-search-toggle]')

    if (!form) return

    function handleToggleClick(event) {
        const toggle = event.currentTarget
        const expanded = toggle.getAttribute('aria-expanded') === 'true'

        expanded ? close(toggle) : open(toggle)
    }

    function updateToggles(value) {
        toggles.forEach((toggle) => {
            toggle.setAttribute('aria-expanded', value)
        })
    }

    function open() {
        const input = form.querySelector('input[type="search"]')
        form.classList.add('is-open')
        updateToggles('true')
        input.focus()
    }

    function close() {
        form.classList.remove('is-open')
        updateToggles('false')
    }

    function isOpen() {
        return form.classList.contains('is-open')
    }

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', handleToggleClick)
    })

    form.addEventListener('click', function (e) {
        if (e.target === form) close()
    })

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close()

        if (e.key === 'k' && (e.ctrlKey || e.metaKey)) {
            isOpen() ? close() : open()
        }
    })
})()
